import { SuccessRateProps } from '../../interface';
import SuccessRateCard from '../../../../../modules/test-app/fundo/[slug]/[id]/components/success-rate/success-rate-card.client';

const withSuccessRateMovableWindow =
  (Component) => (props: SuccessRateProps) => {
    const withSuccessRate = props?.withSuccessRate || false;

    if (!withSuccessRate) {
      return <Component {...props} />;
    }

    return (
      <>
        <Component {...props} />

        <SuccessRateCard identifier={props.assetsIdentifiers as string} />
      </>
    );
  };

export default withSuccessRateMovableWindow;
